// import React, { useEffect } from 'react';
// import ServiceCard from '../components/ServiceCard';
// import AOS from 'aos';
// // import ExteriorService from './exteriordetail';
// // import { FaColumns } from 'react-icons/fa';

// export default function Services() {
//   useEffect(() => {
//     AOS.init({ duration: 1000 });
//   }, []);
//   const animations = [ 'fade-down',"fade-left","fade-right","fade-up",];


//   const services = [
//     {
//       title: "Commercial Painting",
//       shortDesc: "High-quality paint for offices and buildings.",
//       fullDesc: "We specialize in exterior surfaces like buildings, factories, and warehouses using weather-resistant coatings for lasting results.",
//       image: "/Gallerypics/photo-1454165804606-c3d57bc86b40.jpeg",
//       id: "commercial"
//     },
//     {
//       title: "Ceiling Coating",
//       shortDesc: "Expert coatings for ceilings and interiors.",
//       fullDesc: "We specicalize in exterior surfaces like buildings, factories, and warehouses using weather-resistant coatings for lasting results.",
//       image: "/Gallerypics/photo-1631679706909-1844bbd07221.jpeg",
//       id: "ceiling"
//     },
//     {
//       title: "Exterior Projects",
//       shortDesc: "Durable and stylish outdoor painting.",
//       fullDesc: "We specialize in exterior surfaces like buildings, factories, and warehouses using weather-resistant coatings for lasting results.",
//       image: "/Gallerypics/photo-1693691738879-e999316da868.jpeg",
//       id: "exterior"
//     },
//     {
//       title: "Marquee Painting",
//       shortDesc: "Hygienic and high-resistance coatings for large tent and marquee surfaces.",
//       fullDesc: "We specicalize in exterior surfaces like buildings, factories, and warehouses using weather-resistant coatings for lasting results.",
//       image: "/Gallerypics/170ff44e2859fd1e9f2cf19776ef55ab.jpg",
//       id: "marquee"
//     },
//     {
//       title: "Flour Mills",
//       shortDesc: "Clean, durable coatings perfect for industrial food-processing units.",
//       fullDesc: "We specicalize in exterior surfaces like buildings, factories, and warehouses using weather-resistant coatings for lasting results.",
//       image: "/Gallerypics/76608295b5e9c1f4bc3b6951da090bff.jpg",
//       id: "flour"
//     },
//     {
//       title: "Games Area Coating",
//       shortDesc: "Professional paint jobs for play zones, parks, and gyms.",
//       fullDesc: "We specicalize in exterior surfaces like buildings, factories, and warehouses using weather-resistant coatings for lasting results.",
//       image: "/Gallerypics/tennis-court-render-3d-illustration.jpg",
//       id: "games"
//     }
//   ];

//   const handleQuoteClick = (title) => {
//     alert(`Quote requested for ${title}`);
//   };

//   return (
//     <div style={{ padding: '40px 20px', backgroundColor: '#f2f5fa', textAlign: 'center' ,paddingTop:"120px"}}>
//       <h2 style={{ color: '#008080', marginBottom: '30px', fontSize: '28px' }} data-aos="fade-down">Our Services</h2>
//       <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }} 
//             >
//         {services.map((s, i) => (
//           <div key={i} data-aos={animations[i % animations.length]}
//             data-aos-delay={i * 100}>          
//             <ServiceCard
//             key={i}
//             title={s.title}
//            shortDesc={s.shortDesc}   
//            fullDesc={s.fullDesc}
//             image={s.image}
//             id={s.id}
          
//             data-aos={animations[i % animations.length]}
//             data-aos-delay={i * 200}
//             onQuoteClick={() => handleQuoteClick(s.title)}
//           />
//           </div>

//         ))}
//       </div>

// </div>
    
//   );
// }


import React, { useEffect } from 'react';
import ServiceCard from '../components/ServiceCard';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function Services() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const animations = ['fade-down', 'fade-left', 'fade-right', 'fade-up'];

  const services = [
    // { title: "Residential Interior", shortDesc: "Warm, welcoming, and beautiful interiors.", image: "/images/residential-interior.jpg", id: "residential" },
    // { title: "Commercial Interiors", shortDesc: "Professional and inspiring workspaces.", image: "/images/commercial-interior.jpg", id: "commercial" },
    // { title: "Texture & Finishes", shortDesc: "Luxury walls with special textures.", image: "/images/texture-finish.jpg", id: "texture" },
    // { title: "Color Consultation", shortDesc: "Expert advice for perfect color schemes.", image: "/images/color-consultation.jpg", id: "color" },
    // { title: "Wallpaper & Wall Art", shortDesc: "Bold and creative wall designs.", image: "/images/wallpaper-art.jpg", id: "wallpaper" }
        {
      title: "Interior Painting",
      shortDesc: "High-quality paint for offices and buildings.",
      fullDesc: "We specialize in exterior surfaces like buildings, factories, and warehouses using weather-resistant coatings for lasting results.",
      image: "/Gallerypics/photo-1454165804606-c3d57bc86b40.jpeg",
      id: "interior"
    },
    {
      title: "Ceiling Coating",
      shortDesc: "Expert coatings for ceilings and interiors.",
      fullDesc: "We specicalize in exterior surfaces like buildings, factories, and warehouses using weather-resistant coatings for lasting results.",
      image: "/Gallerypics/photo-1631679706909-1844bbd07221.jpeg",
      id: "ceiling"
    },
    {
      title: "Exterior Projects",
      shortDesc: "Durable and stylish outdoor painting.",
      fullDesc: "We specialize in exterior surfaces like buildings, factories, and warehouses using weather-resistant coatings for lasting results.",
      image: "/Gallerypics/photo-1693691738879-e999316da868.jpeg",
      id: "exterior"
    },
    {
      title: "Marquee Painting",
      shortDesc: "Hygienic and high-resistance coatings for large tent and marquee surfaces.",
      fullDesc: "We specicalize in exterior surfaces like buildings, factories, and warehouses using weather-resistant coatings for lasting results.",
      image: "/Gallerypics/170ff44e2859fd1e9f2cf19776ef55ab.jpg",
      id: "marquee"
    },
    {
      title: "Flour Mills",
      shortDesc: "Clean, durable coatings perfect for industrial food-processing units.",
      fullDesc: "We specicalize in exterior surfaces like buildings, factories, and warehouses using weather-resistant coatings for lasting results.",
      image: "/Gallerypics/76608295b5e9c1f4bc3b6951da090bff.jpg",
      id: "flour"
    },
    {
      title: "Games Area Coating",
      shortDesc: "Professional paint jobs for play zones, parks, and gyms.",
      fullDesc: "We specicalize in exterior surfaces like buildings, factories, and warehouses using weather-resistant coatings for lasting results.",
      image: "/Gallerypics/tennis-court-render-3d-illustration.jpg",
      id: "games"
    }
  ];

  return (
    <div style={{ padding: '40px 20px', backgroundColor: '#f2f5fa', textAlign: 'center', paddingTop: "120px" }}>
      <h2 style={{ color: '#008080', marginBottom: '30px', fontSize: '28px' }} data-aos="fade-down">Our Services</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        {services.map((s, i) => (
          <div key={i} data-aos={animations[i % animations.length]} data-aos-delay={i * 100}>
            <ServiceCard {...s} />
          </div>
        ))}
      </div>
    </div>
  );
}
